import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './NavBar.css';

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="navbar">
      <div className="container">
        <div className="menu-icon" onClick={toggleMenu}>
          <i className={isOpen ? 'fas fa-times' : 'fas fa-bars'}></i>
        </div>
        <div className="logo">
          <Link to="/">
            <img src="https://mabrookfiles.com//mybackend/images/logo.png" alt="Mabrook Logo" />
          </Link>
        </div>
        <ul className={`nav-links ${isOpen ? 'active' : ''}`}>
          <li>
            <Link to="/" onClick={toggleMenu}>Home</Link>
          </li>
           <li>
            <Link to="/boir-page" onClick={toggleMenu}>BOIR Reporting</Link>
          </li>
          <li>
            <Link to="/immigration-pricing" onClick={toggleMenu}>Immigration Pricing</Link>
          </li>
           <li>
            <Link to="/boir-form" onClick={toggleMenu}>File BOIR</Link>
          </li>
          <li>
            <Link to="/contact-us" onClick={toggleMenu}>Contact US</Link>
          </li>
          
        </ul>
      </div>
    </nav>
  );
};

export default NavBar;
